import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    const fullMessage = `Hello, I'm ${name} (%20${email})%0A${message}`;
    const phoneNumber = '94778540456';
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(fullMessage)}`;
    window.open(whatsappURL, '_blank');
  };

  return (
    <div
      style={{
        backgroundImage: 'url("https://res.cloudinary.com/dwf8ifbzs/image/upload/v1744277433/jmills_walpaper_2_wme9a7.jpg")',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}
    >
      <div className="bg-white/70 py-16 px-4 sm:px-6 md:px-12 lg:px-32 text-green-900 mt-4">
        <motion.h1
          className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl mb-2 leading-tight bg-gradient-to-r from-green-600 to-yellow-400 bg-clip-text text-transparent  text-center"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Contact Us
        </motion.h1>

        {/* Contact Info */}
        <motion.div
          className="text-base sm:text-lg md:text-xl font-medium space-y-4 text-center mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          <p className="flex items-center justify-center gap-2">
            <MdEmail className="text-green-700 text-2xl" />
            <a href="mailto:info@jayamaloilmills.lk" className="text-green-700 hover:underline">
            info@jayamaloilmills.lk
            </a>
          </p>
          <p className="flex items-center justify-center gap-2">
            <MdPhone className="text-green-700 text-2xl" />
            <a href="tel:+94332255693" className="text-green-700 hover:underline">
              0332255693
            </a>{' '}
            /{' '}
            <a href="tel:+94778540456" className="text-green-700 hover:underline">
              0778540456
            </a>
          </p>
          <p className="flex items-center justify-center gap-2">
            <MdLocationOn className="text-green-700 text-2xl" />
            No. 567, Embaraluwa South, Weliweriya
          </p>
        </motion.div>

        {/* Form Section */}
        <motion.form
          onSubmit={handleSubmit}
          className="max-w-xl mx-auto bg-white rounded-xl shadow-md p-6 space-y-4"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.7 }}
        >
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            className="w-full border border-green-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-400"
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            className="w-full border border-green-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-400"
            value={formData.email}
            onChange={handleChange}
          />
          <textarea
            name="message"
            rows="4"
            placeholder="Your Message"
            required
            className="w-full border border-green-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-400"
            value={formData.message}
            onChange={handleChange}
          />
          <button
            type="submit"
            className="w-full bg-green-600 text-white py-3 px-6 rounded-lg hover:bg-green-700 transition duration-300 flex items-center justify-center gap-2"
          >
            <FaWhatsapp className="text-xl" />
            Send via WhatsApp
          </button>
        </motion.form>

        {/* Quick Actions */}
        <motion.div
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          <a
            href="mailto:info@jayamaloilmills.lk"
            className="bg-yellow-500 text-white py-3 px-6 rounded-xl hover:bg-yellow-600 transition duration-300 flex items-center gap-2"
          >
            <FaEnvelope className="text-xl" />
            Send Email
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default ContactUs;
